import Currency from "./Currency.ts";

export default class FiatCurrency extends Currency {
}
